import './styles/RemoveProcessSelectionStyle.css';
import React, { useEffect, useState } from 'react';
import {
  MenuButton,
  NavigationButton,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import {
  APIResponseStatusType,
  MenuButtonType,
  navigationPages,
} from '../../models/types';
import { useHistory } from 'react-router-dom';
import Removal from '../../resources/images/removal.png';
import ExceptionRemoval from '../../resources/images/exceptionRemoval.png';
import {
  LockerContentRequestGET,
  LockerContentResponseGET,
} from '../../models/cruds';
import { apiErrorHandler, apiGET } from '../../restApi';
import Spinner from 'react-bootstrap/Spinner';

const VALIDATION_ERROR = 'Error en la consulta';
const GET_LOCKER_RACK_CONTENT_EMPTY = 'No hay piezas en el Locker';
const PACKAGE_CODE_MI = 'MI';
const PACKAGE_CODE_EP = 'EP';
const PACKAGE_CODE_ET = 'ET';

const RemoveProcessSelection: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [language, token, lockerRemoveList, lockerContent] = useTypedSelector(
    (state) => {
      return [
        state.session.language,
        state.session.dhlApiToken,
        state.locker.lockerRemoveList,
        state.locker.lockerContent,
      ];
    }
  );
  const { updateLockerContent, updateRemoveLockerList } = useActions();
  useEffect(() => {
    const getlockerContent = async (): Promise<boolean> => {
      setLoading(true);
      let request = new LockerContentRequestGET();
      let response: LockerContentResponseGET = await apiGET(
        request.buildURL(),
        request.generateConfig(token)
      );
      let errorMsg = '';
      try {
        if (response.status === APIResponseStatusType.SUCCESS) {
          if (response.data.lockerRack) {
            let content = response.data.lockerRack;
            if (
              content.lockerPositions &&
              content.lockerPositions.length !== 0
            ) {
              updateLockerContent(content.lockerPositions);
              let expiredPieces = content.lockerPositions.filter((position) => {
                if (
                  position.packageCandidate?.lastPackageStatus.code ===
                    PACKAGE_CODE_MI ||
                  position.packageCandidate?.lastPackageStatus.code ===
                    PACKAGE_CODE_EP ||
                  position.packageCandidate?.lastPackageStatus.code ===
                    PACKAGE_CODE_ET
                ) {
                  return position;
                }
                return null;
              });
              updateRemoveLockerList(expiredPieces);
              setLoading(false);
              return true;
            } else {
              setFeedbackMessage(GET_LOCKER_RACK_CONTENT_EMPTY);
              setLoading(false);
              return false;
            }
          } else {
            //TODO check for unauth and refresh token
            errorMsg = 'Unauthorized';
          }
        } else {
          errorMsg = apiErrorHandler(response);
        }
      } catch (err: any) {
        errorMsg = err.toString();
      }
      console.log(errorMsg);
      setFeedbackMessage(VALIDATION_ERROR);
      setLoading(false);
      return false;
    };
    getlockerContent();
  }, [token, updateLockerContent, updateRemoveLockerList]);
  const removeButtonTitle = () => {
    return (
      languageMap.remove_process_selection.remove[language] +
      ' (' +
      lockerRemoveList.length +
      ')'
    );
  };
  const getRemoveButtonDisabled = (): boolean => {
    if (lockerRemoveList.length === 0) {
      return true;
    }
    return false;
  };
  const getExceptionButtonDisabled = (): boolean => {
    if (lockerContent.length === 0) {
      return true;
    }
    return false;
  };
  const removeButton = {
    key: 'removeButton1',
    title: removeButtonTitle(),
    content: Removal,
    action: () => history.replace(`/${navigationPages.REMOVE_PIECE}`),
    disabled: getRemoveButtonDisabled(),
  };
  const removeExcelptionButton = {
    key: 'exceptionButton1',
    title: languageMap.remove_process_selection.remove_exception[language],
    content: ExceptionRemoval,
    action: () => history.replace(`/${navigationPages.REMOVE_VALIDATE_AWB}`),
    disabled: getExceptionButtonDisabled(),
  };
  const buttonList: MenuButtonType[] = [removeButton, removeExcelptionButton];
  const renderContent = () => {
    if (loading) {
      return (
        <div className="employee-number-numpad-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <div className="insert-selection-button-container">
        {buttonList.map((button: MenuButtonType) => {
          return (
            <MenuButton
              key={button.key}
              buttonTitle={button.title}
              buttonContent={button.content}
              buttonClass="medium"
              iconClass="medium"
              onClickButton={() => {
                if (button.action && typeof button.action === 'function') {
                  button.action();
                }
              }}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div id="removeProcessSelection" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.remove_process_selection.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.remove_process_selection.cancel_button[language]
                }
                buttonClass="navigation-button cancel-button complete"
                onClickButton={() => {
                  history.replace(
                    `/${navigationPages.AGENT_PROCESS_SELECTION}`
                  );
                }}
              />
            </div>
            <div className="footer-button-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { RemoveProcessSelection };
